import MaterialTable from '@material-table/core'
import { NumericFormat } from 'react-number-format'
import { timezoneDate, currencyFormatter } from 'utils/helpers'
import { getCurrency } from 'utils/authService'
import { fromConstantPropertyToSelectValue } from 'utils/serializers'
import { ExportCsv, ExportPdf } from '@material-table/exporters'

const columns = [
  {
    title: 'Name',
    field: 'name',
    sorting: true,
    render: row => (
      <a href={`/opportunities/${row.dealId}`} target="_blank" rel="noreferrer">
        {row.name}
      </a>
    )
  },
  {
    title: 'Due Date',
    field: 'dueDate',
    sorting: true,
    render: row => (row.dueDate ? timezoneDate(row.dueDate) : null),
    exportTransformer: row => (row.dueDate ? timezoneDate(row.dueDate) : null)
  },
  {
    title: 'FollowUp Date',
    field: 'followUpDate',
    sorting: true,
    render: row => (row.followUpDate ? timezoneDate(row.followUpDate) : null),
    exportTransformer: row => (row.followUpDate ? timezoneDate(row.followUpDate) : null)
  },
  {
    title: 'Status',
    field: 'status',
    sorting: false,
    render: row => row.status.name,
    exportTransformer: row => (row.status ? row.status.name : null)
  },
  {
    title: 'Value',
    field: 'value',
    sorting: true,
    render: row => (
      <NumericFormat
        thousandSeparator
        decimalScale={2}
        value={row.value}
        prefix={getCurrency().symbol}
        displayType="text"
      />
    ),
    exportTransformer: row => currencyFormatter({ value: row.value })
  },
  {
    title: 'Deal Manager',
    field: 'dealManager',
    sorting: true,
    render: row => `${row.dealManager.firstName} ${row.dealManager.lastName}`,
    exportTransformer: row =>
      row.dealManager ? `${row.dealManager.firstName} ${row.dealManager.lastName}` : null
  },
  {
    title: 'Role',
    field: 'role',
    sorting: false,
    render: row => fromConstantPropertyToSelectValue(row.role, 'DealClientRole')?.label,
    exportTransformer: row =>
      row.role ? fromConstantPropertyToSelectValue(row.role, 'DealClientRole').label : null
  }
]

const DealsTable = ({ companyDeals, contactDeals, label, removeContactFromDeal }) => (
  <MaterialTable
    title=""
    columns={columns}
    data={companyDeals || contactDeals}
    options={{
      actionsColumnIndex: -1,
      sorting: true,
      headerStyle: {
        backgroundColor: '#eee',
        color: '#000',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        fontSize: '14px'
      },
      pageSize: 10,
      pageSizeOptions: [10, 20, 50],
      padding: 'dense',
      exportMenu: [
        {
          label: 'Export PDF',
          exportFunc: (cols, datas) => ExportPdf(cols, datas, label)
        },
        {
          label: 'Export CSV',
          exportFunc: (cols, datas) => ExportCsv(cols, datas, label)
        }
      ]
    }}
    style={{
      boxShadow: 'none',
      fontSize: '13px'
    }}
    actions={
      removeContactFromDeal
        ? [
            {
              icon: 'delete',
              tooltip: 'Remove from Opportunity',
              onClick: (event, rowData) => removeContactFromDeal(rowData.dealId, name)
            }
          ]
        : []
    }
  />
)

export default DealsTable
